import { useOpenApiMutation } from "@packages/sdk";

const urlBackendPath = "/me/web-push-subscription";

export const useRequestNotificationSubscribe = () => ({
  subscribe: useOpenApiMutation<"POST", typeof urlBackendPath>({
    urlBackendPath,
    method: "POST",
  }),
  unsubscribe: useOpenApiMutation<"DELETE", typeof urlBackendPath>({
    urlBackendPath,
    method: "DELETE",
  }),
});
